import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ReactLink from '@client/components/reactLink/ReactLink';
import styles from './footerItem.scss';

class FooterItem extends PureComponent {
  render() {
    const { item, color, className } = this.props;
    if (item.divider) {
      let dividerClassName = styles.divider;
      if (className) {
        dividerClassName += ` ${className}`;
      }
      return <div className={dividerClassName} />;
    }
    let footerItemClassName = styles.footerItem;
    if (className) {
      footerItemClassName += ` ${className}`;
    }
    return (
      <ReactLink to={item.route}>
        <p style={{ color: color }} className={footerItemClassName}>
          {item.title}
        </p>
      </ReactLink>
    );
  }
}

FooterItem.propTypes = {
  item: PropTypes.object,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default withRouter(FooterItem);
